const subscribeToTokenUpdate = (
    configUpdate$,
    userActionsRequest$,
) =>
    configUpdate$
        .subscribe(latestToken => {
            const request = {
                token: latestToken,
            };

            userActionsRequest$.next(request);
        });

export default subscribeToTokenUpdate;
